module.exports = __webpack_public_path__ + "img/resources.76a519b9.png";